import {
    makeStyles,
} from 'app/tss'

const contractInfo = 'contractInfo'
const summary = 'summary'
const billingInformation = 'billingInformation'
const comments = 'comments'

const useStyles = makeStyles()((theme) => {
    return {
        gridWrapperOrder: {
            display: 'grid',
            gap: theme.spacing(2),
            gridTemplateAreas: `
                "${contractInfo} ${summary} ${summary} ${billingInformation}"
                "${comments} ${comments} ${comments} ${comments}"
                `,
            gridTemplateColumns: 'repeat(4, 1fr)',
            paddingTop: theme.spacing(1),
        },
        billingInformation: {
            gridArea: billingInformation,
        },
        summary: {
            gridArea: summary,
        },
        comments: {
            gridArea: comments,
        },
        contractInfo: {
            gridArea: contractInfo,
        },
    }
})

export default useStyles
